import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { socialMediaService } from "@/services/api/cresivoxServer";
import { iSocialMediaDTO } from "./Types";

const REDUCER_NAME = "form";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const addSocialMedia = createAsyncThunk<
  iGenericResponse<any | null> | null, 
  {data:iSocialMediaDTO}, 
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("addSocialMedia"),
   // @ts-expect-error abc 
  async ({data}, { rejectWithValue }) => {

    try {
      const response = await socialMediaService.addSocialMedia(data); 

      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_CREATED:
            return { httpStatusCode, data, message };
          default:
            return rejectWithValue({ httpStatusCode, message });
        }
      } else {
        return rejectWithValue({ message: "No response received" });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);


export const deleteSocialMedia = createAsyncThunk<
  iGenericResponse<any | null> | null, 
  {socialId:string}, 
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("deleteSocialMedia"),
   // @ts-expect-error abc 
  async ({socialId}, { rejectWithValue }) => {

    try {
      const response = await socialMediaService.deleteSocialMedia(socialId); 

      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK:
            return { httpStatusCode, data, message };
          default:
            return rejectWithValue({ httpStatusCode, message });
        }
      } else {
        return rejectWithValue({ message: "No response received" });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);


export const getSocialMediaList = createAsyncThunk<
  iGenericResponse<any | null> | null, 
  null, 
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("getSocialMediaList"),
   // @ts-expect-error abc 
  async (formData, { rejectWithValue }) => {

    try {
      const response = await socialMediaService.getSocialMediaList(); 

      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK:
            return { httpStatusCode, data, message };
          default:
            return rejectWithValue({ httpStatusCode, message });
        }
      } else {
        return rejectWithValue({ message: "No response received" });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);





  